export interface Purchase {
  name: string
  city: string
  region: string
}

export const purchases: Purchase[] = [
  { name: 'Michael D.', city: 'Columbus, Ohio', region: 'United States' },
  { name: 'Sarah W.', city: 'Manchester', region: 'United Kingdom' },
  { name: 'David L.', city: 'Toronto, ON', region: 'Canada' },
  { name: 'Emma C.', city: 'Brisbane, QLD', region: 'Australia' },
  { name: 'Robert J.', city: 'Denver, Colorado', region: 'United States' },
  { name: 'Claire H.', city: 'Leeds', region: 'United Kingdom' },
  { name: 'Jason M.', city: 'Vancouver, BC', region: 'Canada' },
  { name: 'Olivia T.', city: 'Melbourne, VIC', region: 'Australia' },
  { name: 'Brian K.', city: 'Austin, Texas', region: 'United States' },
  { name: 'Aaron P.', city: 'Calgary, AB', region: 'Canada' },
  { name: 'Rachel S.', city: 'Birmingham', region: 'United Kingdom' },
  { name: 'Nathan B.', city: 'Perth, WA', region: 'Australia' },
  { name: 'Megan R.', city: 'Chicago, Illinois', region: 'United States' },
  { name: 'Liam O.', city: 'Glasgow', region: 'United Kingdom' },
  { name: 'Chris V.', city: 'Sydney, NSW', region: 'Australia' },
]
